import noop from 'lodash/noop';
import { GRAPH_REDIRECT } from '../../custom-report.serivce';
import PMEditSection from './PMEditSection/PMEditSection';
import EditSection from './EditSection/EditSection';
import ReportedEditSection from './ReportedEditSection/ReportedEditSection';

const DEFAULT_EDIT_CONFIG = {
  isEditable: false,
  editableFields: {},
  goToSettings: {},
  onChange: noop,
  onSave: noop,
  onRemove: noop,
  EditSection
};

export const EDIT_CONFIG_BY_WIDGET_TYPE = {
  default: ({ graph, onChange }) => ({
    ...DEFAULT_EDIT_CONFIG,
    onChange,
    editableFields: {
      color: graph.color ?? 'dodgerBlue',
      type: graph.type,
      agg: graph.agg ?? 'avg'
    },
    goToSettings: GRAPH_REDIRECT[graph.goToSettingsType] ?? {}
  }),
  custom: ({ graph, onSave, onChange, onRemove }) => ({
    isEditable: true,
    editableFields: {
      color: graph.color ?? 'dodgerBlue',
      type: graph.type,
      agg: graph.agg ?? 'avg'
    },
    onChange: onChange ?? noop,
    onSave: onSave ?? onChange ?? noop,
    onRemove: onRemove ?? noop,
    EditSection,
    goToSettings: GRAPH_REDIRECT[graph.goToSettingsType] ?? {}
  }),
  customPmMetrics: ({ graph, onSave, onChange, onRemove }) => ({
    isEditable: true,
    editableFields: {
      color: graph.color ?? 'dodgerBlue'
    },
    onChange: onChange || noop,
    onSave: onSave ?? onChange ?? noop,
    onRemove: onRemove || noop,
    EditSection: PMEditSection,
    goToSettings: {}
  }),
  reportedMetrics: ({ graph, onSave, onChange, onRemove }) => ({
    isEditable: true,
    editableFields: {
      color: graph.color ?? 'dodgerBlue'
    },
    onChange: onChange || noop,
    onSave: onSave ?? onChange ?? noop,
    onRemove: onRemove || noop,
    EditSection: ReportedEditSection,
    goToSettings: {}
  })
};
